import {
  Component,
  OnInit,
  inject,
  effect,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { ColumnState, GridApi, GridReadyEvent } from "ag-grid-community";
import { DataService } from "src/app/data.service";
import { db } from "src/app/db.service";
import { ProductsService } from "src/app/products/products.service";
import { StockService } from "src/app/stock/stock.service";
import * as _moment from "moment";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
const moment = _moment;

@Component({
  selector: "app-profit",
  templateUrl: "./profit.component.html",
  styleUrls: ["./profit.component.css"],
})
export class ProfitComponent {
  dialog = inject(MatDialog);
  _dataService = inject(DataService);
  _productService = inject(ProductsService);
  _stockService = inject(StockService);
  dataLoading: boolean = true;
  navButtons = [
    {
      name: "",
      icon: "",
      function: () => null,
    },
  ];
  columnDefs = [
    {
      headerName: "Tipi",
      field: "bankGroup",
      flex: 2,
      minWidth: 100,
    },
    { headerName: "Tərəf-Müqabil", field: "customerName", flex: 2 },
    {
      headerName: "Alınan, ₼",
      field: "income",
      flex: 1,
    },
    {
      headerName: "Ödənən, ₼",
      field: "outgoings",
      flex: 1,
    },
    {
      headerName: "Tarix",
      field: "date",
      flex: 1,
      minWidth: 120,
      sortable: true,
    },
    {
      headerName: "Məlumat",
      field: "details",
      flex: 2,
      minWidth: 100,
      cellClass: (params) => {
        return "justify-content-start clipText";
      },
    },
  ];
  protected gridApi!: GridApi;
  agGridData$;
  sellsTotal: number = 0;
  costTotal: number = 0;
  administrativXercler: number = 0;
  materials;
  status: any = null;
  now = moment(Date.now());
  menfeet: number = 0;
  maliyyet: number = 0;
  prevMaliyyet: number = 0;
  sellsIncome: number = 0;
  prevSellsIncome: number = 0;
  xammalPayments: number = 0;
  prevXammalPayments: number = 0;
  otherIncome: number = 0;
  prevOtherIncome: number = 0;
  xammalIncomes: number = 0;
  prevXammalIncomes: number = 0;

  @ViewChild("tableDialogTemplate") tableDialogTemplate!: TemplateRef<any>;

  dialogRef!: MatDialogRef<any>;

  constructor() {
    effect(async () => {
      if (this._dataService.dateChangedSig()) {
        this.status = await this.getComprehensiveFinancialStatus();
        let m = this.status.currentPeriod.bankAnalysis.outgoingsByCategory.find(
          (o: any) => o.name == "Mənfəət"
        );
        this.menfeet = m?.out ?? 0;
        this.maliyyet =
          this.status.currentPeriod.profitAndLossPeriod.periodCostOfGoodsSold;
        this.prevMaliyyet =
          this.status.prevPeriod.profitAndLossPeriod.periodCostOfGoodsSold;
        const otherIncomeIds: string[] = this._dataService
          .bankGroups()
          .filter((bg: any) => bg.bankGroupCategory !== 2)
          .map((bg: any) => bg.id);
        this.otherIncome =
          this.status.currentPeriod.bankAnalysis.incomesByCategory
            .filter(
              (item) =>
                item.name !== "Satış" &&
                item.name !== "Köçürmə" &&
                otherIncomeIds.includes(item.bankGroupId)
            )
            .reduce((sum, item) => sum + item.in, 0);
        this.prevOtherIncome =
          this.status.prevPeriod.bankAnalysis.incomesByCategory
            .filter((item) => item.name !== "Satış" && item.name !== "Köçürmə")
            .reduce((sum, item) => sum + item.in, 0);
        let x = this.status.currentPeriod.bankAnalysis.outgoingsByCategory.find(
          (o: any) => o.name == "Xammal"
        );
        this.xammalPayments = x?.out ?? 0;
        x = this.status.prevPeriod.bankAnalysis.outgoingsByCategory.find(
          (o: any) => o.name == "Xammal"
        );
        this.prevXammalPayments = x?.out ?? 0;

        const xammalIncomeIds: string[] = this._dataService
          .bankGroups()
          .filter((bg: any) => bg.bankGroupCategory == 2)
          .map((bg: any) => bg.id);
        this.xammalIncomes =
          this.status.currentPeriod.bankAnalysis.incomesByCategory
            .filter((item) => xammalIncomeIds.includes(item.bankGroupId))
            .reduce((sum, item) => sum + item.in, 0);
        this.prevXammalIncomes =
          this.status.prevPeriod.bankAnalysis.incomesByCategory
            .filter((item) => xammalIncomeIds.includes(item.bankGroupId))
            .reduce((sum, item) => sum + item.in, 0);
        console.log("prev: ", this.prevXammalIncomes);
        this.now = moment(Date.now());
      }
    });
  }

  // Optimized getComprehensiveFinancialStatus using formula-based material tracking
  async getComprehensiveFinancialStatus() {
    this.dataLoading = true;

    // --- I. Initial Setup & Date Definitions ---
    const currentPeriodStartDateString: any =
      this._dataService.startDate.value.format("YYYY-MM-DD");
    const currentPeriodEndDateString: any =
      this._dataService.endDate.value.format("YYYY-MM-DD");

    const formatDateForDb = (d: Date): string => {
      const year: any = d.getFullYear();
      const month: any = (d.getMonth() + 1).toString().padStart(2, "0");
      const day: any = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const getPreviousPeriodRange = (
      currentStartStr: string,
      currentEndStr: string
    ) => {
      const currentStart: Date = new Date(currentStartStr);
      const currentEnd: Date = new Date(currentEndStr);
      const today: Date = new Date();
      today.setHours(0, 0, 0, 0);

      let prevStart: Date;
      let prevEnd: Date;

      const isCurrentPeriodFullYearEndingDec31 =
        currentStart.getDate() === 1 &&
        currentStart.getMonth() === 0 &&
        currentEnd.getDate() === 31 &&
        currentEnd.getMonth() === 11;

      if (isCurrentPeriodFullYearEndingDec31) {
        prevStart = new Date(currentStart.getFullYear() - 1, 0, 1);
        prevEnd = new Date(
          today.getFullYear() - 1,
          today.getMonth(),
          today.getDate()
        );
        const endOfPrevYear = new Date(currentStart.getFullYear() - 1, 11, 31);
        if (prevEnd > endOfPrevYear) {
          prevEnd = endOfPrevYear;
        }
      } else {
        let effectiveCurrentEnd: Date = new Date(currentEnd);
        if (currentEnd > today) {
          effectiveCurrentEnd = new Date(today);
        }

        prevStart = new Date(currentStart);
        prevStart.setMonth(currentStart.getMonth() - 1);
        if (
          prevStart.getDate() !== currentStart.getDate() &&
          currentStart.getDate() > 28
        ) {
          prevStart.setDate(0);
        }

        prevEnd = new Date(effectiveCurrentEnd);
        const originalEffectiveEndDay: number = effectiveCurrentEnd.getDate();
        prevEnd.setMonth(effectiveCurrentEnd.getMonth() - 1);

        if (
          prevEnd.getDate() !== originalEffectiveEndDay &&
          originalEffectiveEndDay > 28
        ) {
          prevEnd.setDate(0);
        }
      }

      if (prevStart > prevEnd) {
        prevEnd = new Date(prevStart.getTime());
      }

      return {
        startDateString: formatDateForDb(prevStart),
        endDateString: formatDateForDb(prevEnd),
      };
    };

    const previousPeriodDateStrings: any = getPreviousPeriodRange(
      currentPeriodStartDateString,
      currentPeriodEndDateString
    );

    const excludedPaymentCategoryIds: any[] =
      this._dataService.getLS("YOUR_LS_KEY_FOR_EXCLUDED_BANK_GROUPS") || [];
    const customerGroupInclusionFilters: any[] =
      this._dataService.getLS(
        `${this._dataService.dbTable}_filteredCustomerGroups`
      ) || [];

    // --- II. Formula-Based Material Calculation Helper Class ---
    class FormulaBasedCalculator {
      private materialsMap: Map<number, any>;
      private formulaGroupsMap: Map<number, any>;
      private formulasMap: Map<number, any[]>;

      constructor(materials: any[], formulaGroups: any[], formulas: any[]) {
        this.materialsMap = new Map(materials.map((m) => [m.id, m]));
        this.formulaGroupsMap = new Map(formulaGroups.map((fg) => [fg.id, fg]));

        // Group formulas by formulaGroupId for quick lookup
        this.formulasMap = new Map();
        formulas.forEach((formula) => {
          if (!this.formulasMap.has(formula.formulaGroupId)) {
            this.formulasMap.set(formula.formulaGroupId, []);
          }
          this.formulasMap.get(formula.formulaGroupId).push(formula);
        });
      }

      // Calculate materials used in a specific production
      calculateMaterialsUsedInProduction(production: any): {
        materialId: number;
        quantity: number;
        price: number;
        cost: number;
      }[] {
        if (!production.formulaGroupId) return [];

        const formulas = this.formulasMap.get(production.formulaGroupId) || [];
        const usedMaterials = [];

        for (const formula of formulas) {
          const material = this.materialsMap.get(formula.materialId);
          if (!material) continue;

          let usedQuantity = 0;

          // Calculate based on material unit (your existing logic)
          switch (
            material.unitType // Changed from 'unit' to 'unitType' based on your schema
          ) {
            case "ədəd":
              usedQuantity = parseFloat(production.quantity.toFixed(5));
              break;
            case "m":
            case "m2":
              usedQuantity = parseFloat(
                (production.quantity / production.length).toFixed(5)
              );
              break;
            default:
              usedQuantity = parseFloat(
                (
                  (formula.quantity / production.formulaTotalWeight) *
                  production.weight *
                  production.quantity *
                  production.length
                ).toFixed(5)
              );
              break;
          }

          usedMaterials.push({
            materialId: formula.materialId,
            quantity: usedQuantity,
            price: material.price,
            cost: usedQuantity * material.price,
          });
        }

        return usedMaterials;
      }

      // Calculate total material usage for a list of productions
      calculateTotalMaterialUsage(productions: any[]): {
        totalMaterialsUsedQuantity: number;
        totalMaterialsUsedPrice: number;
        materialBreakdown: Map<number, { quantity: number; cost: number }>;
      } {
        let totalQuantity = 0;
        let totalCost = 0;
        const materialBreakdown = new Map<
          number,
          { quantity: number; cost: number }
        >();

        for (const production of productions) {
          const usedMaterials =
            this.calculateMaterialsUsedInProduction(production);

          for (const material of usedMaterials) {
            totalQuantity += material.quantity;
            totalCost += material.cost;

            const existing = materialBreakdown.get(material.materialId) || {
              quantity: 0,
              cost: 0,
            };
            existing.quantity += material.quantity;
            existing.cost += material.cost;
            materialBreakdown.set(material.materialId, existing);
          }
        }

        return {
          totalMaterialsUsedQuantity: totalQuantity,
          totalMaterialsUsedPrice: totalCost,
          materialBreakdown,
        };
      }

      // Calculate current material stock levels (excluding production usage)
      calculateCurrentMaterialStock(
        stockTransactions: any[],
        productions: any[]
      ): Map<number, { quantity: number; value: number }> {
        const materialBalances = new Map<
          number,
          { quantity: number; value: number }
        >();

        // First, add all direct stock transactions (purchases, adjustments)
        stockTransactions.forEach((stock) => {
          const existing = materialBalances.get(stock.materialId) || {
            quantity: 0,
            value: 0,
          };
          existing.quantity += Number(stock.quantity) || 0;
          existing.value +=
            (Number(stock.quantity) || 0) * (Number(stock.price) || 0);
          materialBalances.set(stock.materialId, existing);
        });

        // Then, subtract production usage
        for (const production of productions) {
          const usedMaterials =
            this.calculateMaterialsUsedInProduction(production);

          for (const material of usedMaterials) {
            const existing = materialBalances.get(material.materialId) || {
              quantity: 0,
              value: 0,
            };
            existing.quantity -= material.quantity;
            existing.value -= material.cost;
            materialBalances.set(material.materialId, existing);
          }
        }

        return materialBalances;
      }
    }

    // --- III. Reusable Core Metric Calculation Function (OPTIMIZED) ---
    const calculateMetricsForPeriod = async (
      periodStartStr: string,
      periodEndStr: string,
      isMainCurrentPeriodQuery: boolean
    ) => {
      const periodStartDateObj: any = new Date(periodStartStr);
      const periodEndDateObj: any = new Date(periodEndStr);

      const customersList_calc: any = this._dataService.customers();
      const bankGroupsList_calc: any = this._dataService.bankGroups();
      const bankGroupsMap_calc: any = new Map(
        bankGroupsList_calc.map((bg: any) => [bg.id?.toString(), bg])
      );
      const materialsList_calc: any = this._dataService.materials();
      const materialsMap_calc: any = new Map(
        materialsList_calc.map((m: any) => [m.id, m])
      );
      const productsList_calc: any = this._dataService.products();
      const productsMap_calc: any = new Map(
        productsList_calc.map((p: any) => [p.id, p])
      );
      const formulaGroupsMap_calc: any = new Map(
        this._dataService.formulaGroups().map((fg: any) => [fg.id, fg])
      );

      // Get all data up to period end
      const currentPeriodAllBankTx: any = await db.bank
        .where("date")
        .belowOrEqual(periodEndStr)
        .toArray();
      const currentPeriodAllSellsTx: any = await db.sells
        .where("date")
        .belowOrEqual(periodEndStr)
        .toArray();

      // OPTIMIZATION: Only get stock transactions that are NOT production-related
      // Production material usage will be calculated from formulas
      const currentPeriodAllStockTx: any = await db.stock
        .where("date")
        .belowOrEqual(periodEndStr)
        .filter((stock) => !stock.tType || stock.tType !== "Production")
        .toArray();

      const currentPeriodAllProductionTx: any = await db.production
        .where("date")
        .belowOrEqual(periodEndStr)
        .toArray();

      // Initialize Formula-Based Calculator
      const formulaCalculator = new FormulaBasedCalculator(
        materialsList_calc,
        this._dataService.formulaGroups(),
        this._dataService.formulas()
      );

      const periodSpecificSellsTx: any = currentPeriodAllSellsTx.filter(
        (t: any) => {
          const itemDate: any = new Date(t.date);
          return itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;
        }
      );

      const periodSpecificBankTx: any = currentPeriodAllBankTx.filter(
        (t: any) => {
          const itemDate: any = new Date(t.date);
          return itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;
        }
      );

      const periodSpecificProductionTx: any =
        currentPeriodAllProductionTx.filter((t: any) => {
          const itemDate: any = new Date(t.date);
          return itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;
        });

      const metrics: any = {
        bankAnalysis: {
          inCurrentPeriod: 0,
          outCurrentPeriod: 0,
          residueBeforePeriod: 0,
          outBalanceCurrentPeriod: 0,
          inBalanceCurrentPeriod: 0,
          residueBalanceBeforePeriod: 0,
          sellsIncomeViaBank0: 0,
          outgoingsByCategory: [],
          incomesByCategory: [],
        },
        sellsAnalysis: {
          sellsCurrentPeriod: 0,
          returnsCurrentPeriod: 0,
          residueValueBeforePeriod: 0,
        },
        stockMovementsAnalysis: {
          inCurrentPeriod: 0,
          outCurrentPeriod: 0,
          residueValueBeforePeriod: 0,
          inBalanceCurrentPeriod: 0,
          outBalanceCurrentPeriod: 0,
          residueBalanceBeforePeriod: 0,
        },
        inventoryValues: {
          currentTotalMaterialsValue: 0,
          currentTotalProductsValue: 0,
        },
        customerBalances: {
          totalAccountsReceivable: 0,
          totalCustomerCreditsPayable: 0,
        },
        productionPeriodReport: {
          totalMaterialsUsedQuantity: 0,
          totalMaterialsUsedPrice: 0,
          productsProducedVolumeCalc: 0,
        },
        profitAndLossPeriod: {
          periodSellsValue: 0,
          periodCostOfGoodsSold: 0,
          periodAdministrativeExpenses: 0,
          otherExpenses: 0,
          periodGrossProfit: 0,
        },
      };

      const getProductUnitCostLocal = (productId: any): number => {
        const productDetails: any = productsMap_calc.get(productId);
        if (!productDetails) return 0;

        let baseFormulaCost: number = 0;
        const formulaGroup: any = productDetails.formulaGroupId
          ? formulaGroupsMap_calc.get(productDetails.formulaGroupId)
          : null;

        const formulaCostVal: number = formulaGroup?.cost || 0;

        if (typeof productDetails.weight === "number") {
          baseFormulaCost =
            productDetails.width && productDetails.width !== 0
              ? (formulaCostVal * productDetails.weight) / productDetails.width
              : formulaCostVal * productDetails.weight;
          baseFormulaCost = isNaN(baseFormulaCost) ? 0 : baseFormulaCost;
        }

        const uzlemeCost: number =
          typeof productDetails.uzleme === "number" ? productDetails.uzleme : 0;
        const totalCost: number = baseFormulaCost + uzlemeCost;
        return isNaN(totalCost) ? 0 : totalCost;
      };

      // V.A. Bank Analysis (unchanged)
      const periodOutgoingsAggregator: any = {};
      const periodIncomesAggregator: any = {};

      currentPeriodAllBankTx.forEach((tx: any) => {
        const itemDate: any = new Date(tx.date);
        const income: any = Number(tx.income) || 0;
        const outgoings: any = Number(tx.outgoings) || 0;
        const bankGroup: any = bankGroupsMap_calc.get(
          tx.bankGroupId?.toString()
        );
        const isInThisPeriod: boolean =
          itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;

        if (isInThisPeriod) {
          metrics.bankAnalysis.inCurrentPeriod += income;
          metrics.bankAnalysis.outCurrentPeriod += outgoings;
          if (bankGroup?.includeInBalance) {
            metrics.bankAnalysis.outBalanceCurrentPeriod += outgoings;
            metrics.bankAnalysis.inBalanceCurrentPeriod += income;
          }
          if (tx.bankGroupId === 0)
            metrics.bankAnalysis.sellsIncomeViaBank0 += income;

          if (outgoings > 0) {
            const groupId: any = tx.bankGroupId;
            periodOutgoingsAggregator[groupId] = periodOutgoingsAggregator[
              groupId
            ] || {
              name: bankGroup?.name || `Group ${groupId}`,
              bankGroupId: groupId,
              out: 0,
            };
            periodOutgoingsAggregator[groupId].out += outgoings;
          }
          if (income > 0) {
            const groupId: any = tx.bankGroupId;
            periodIncomesAggregator[groupId] = periodIncomesAggregator[
              groupId
            ] || {
              name: bankGroup?.name || `Group ${groupId}`,
              bankGroupId: groupId,
              in: 0,
            };
            periodIncomesAggregator[groupId].in += income;
          }
        } else if (itemDate < periodStartDateObj) {
          metrics.bankAnalysis.residueBeforePeriod += income - outgoings;
          if (bankGroup?.includeInBalance) {
            metrics.bankAnalysis.residueBalanceBeforePeriod +=
              income - outgoings;
          }
        }
      });

      metrics.bankAnalysis.outgoingsByCategory = Object.values(
        periodOutgoingsAggregator
      ).sort((a: any, b: any) => b.out - a.out);
      metrics.bankAnalysis.incomesByCategory = Object.values(
        periodIncomesAggregator
      ).sort((a: any, b: any) => b.in - a.in);

      // V.B. Sells Analysis (unchanged)
      currentPeriodAllSellsTx.forEach((tx: any) => {
        const itemDate: any = new Date(tx.date);
        const quantity: any = Number(tx.quantity) || 0;
        const price: any = Number(tx.price) || 0;
        const transactionValue: any = quantity * price;
        const isInThisPeriod: boolean =
          itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;

        if (isInThisPeriod) {
          if (quantity > 0)
            metrics.sellsAnalysis.sellsCurrentPeriod += transactionValue;
          else if (quantity < 0)
            metrics.sellsAnalysis.returnsCurrentPeriod += transactionValue;
        } else if (itemDate < periodStartDateObj) {
          metrics.sellsAnalysis.residueValueBeforePeriod += transactionValue;
        }
      });

      // V.C. OPTIMIZED Stock Movements Analysis (excluding production-related)
      currentPeriodAllStockTx.forEach((tx: any) => {
        const itemDate: any = new Date(tx.date);
        const quantity: any = Number(tx.quantity) || 0;
        const price: any = Number(tx.price) || 0;
        const transactionValue: any = quantity * price;
        const isInThisPeriod: boolean =
          itemDate >= periodStartDateObj && itemDate <= periodEndDateObj;

        if (isInThisPeriod) {
          if (quantity > 0) {
            metrics.stockMovementsAnalysis.inCurrentPeriod += transactionValue;
            if (tx.customerId)
              metrics.stockMovementsAnalysis.inBalanceCurrentPeriod +=
                transactionValue;
          } else if (quantity < 0) {
            metrics.stockMovementsAnalysis.outCurrentPeriod += transactionValue;
            if (tx.customerId)
              metrics.stockMovementsAnalysis.outBalanceCurrentPeriod +=
                transactionValue;
          }
        } else if (itemDate < periodStartDateObj) {
          metrics.stockMovementsAnalysis.residueValueBeforePeriod +=
            transactionValue;
          if (tx.customerId)
            metrics.stockMovementsAnalysis.residueBalanceBeforePeriod +=
              transactionValue;
        }
      });

      // V.D. OPTIMIZED Inventory Values (using formula-based calculation)
      const currentMaterialStock =
        formulaCalculator.calculateCurrentMaterialStock(
          currentPeriodAllStockTx,
          currentPeriodAllProductionTx
        );

      // Calculate current materials value from optimized stock calculation
      currentMaterialStock.forEach((stockInfo, materialId) => {
        if (stockInfo.quantity > 0) {
          const material = materialsMap_calc.get(materialId);
          if (material) {
            metrics.inventoryValues.currentTotalMaterialsValue +=
              stockInfo.quantity * material.price;
          }
        }
      });

      // Products inventory calculation (unchanged)
      const invCurrentProductQtys: any = {};
      currentPeriodAllProductionTx.forEach((p: any) => {
        invCurrentProductQtys[p.productId] =
          (invCurrentProductQtys[p.productId] || 0) + (Number(p.quantity) || 0);
      });
      currentPeriodAllSellsTx.forEach((s: any) => {
        if (s.productId) {
          invCurrentProductQtys[s.productId] =
            (invCurrentProductQtys[s.productId] || 0) -
            (Number(s.quantity) || 0);
        }
      });
      productsList_calc.forEach((product: any) => {
        const currentQty: any = invCurrentProductQtys[product.id] || 0;
        if (currentQty > 0) {
          const unitCost: any = getProductUnitCostLocal(product.id);
          metrics.inventoryValues.currentTotalProductsValue +=
            currentQty * unitCost;
        }
      });

      // V.E. Customer Balances (modified to exclude production-related stock transactions)
      const periodCustomerAggregates: any = {};
      customersList_calc.forEach((cust: any) => {
        periodCustomerAggregates[cust.id] = {
          rawCustomerGroupId: cust.customerGroupId,
          sellsTotal: 0,
          sellsBefore: 0,
          incomeTotal: 0,
          incomeBefore: 0,
          outgoingTotal: 0,
          outgoingBefore: 0,
          stocksTotal: 0,
          stocksBefore: 0,
          incomeWithoutBalance: 0,
          outgoingWithoutBalance: 0,
          rawCustomerOpeningBalance: Number(cust.balance) || 0,
        };
      });

      // Only use non-production stock transactions for customer balances
      currentPeriodAllStockTx.forEach((item: any) => {
        if (item.customerId && periodCustomerAggregates[item.customerId]) {
          const agg: any = periodCustomerAggregates[item.customerId];
          const itemDate: any = new Date(item.date);
          const value: number =
            (Number(item.quantity) || 0) * (Number(item.price) || 0);

          if (itemDate >= periodStartDateObj && itemDate <= periodEndDateObj) {
            if (value >= 0) agg.stocksTotal += value;
            else agg.sellsTotal -= value;
          } else if (itemDate < periodStartDateObj) {
            if (value >= 0) agg.stocksBefore += value;
            else agg.sellsBefore -= value;
          }
        }
      });

      // Rest of customer balance calculation remains the same...
      currentPeriodAllSellsTx.forEach((item: any) => {
        if (item.customerId && periodCustomerAggregates[item.customerId]) {
          const agg: any = periodCustomerAggregates[item.customerId];
          const itemDate: any = new Date(item.date);
          const value: number =
            (Number(item.quantity) || 0) * (Number(item.price) || 0);

          if (itemDate >= periodStartDateObj && itemDate <= periodEndDateObj) {
            if (value >= 0) agg.sellsTotal += value;
            else agg.stocksTotal -= value;
          } else if (itemDate < periodStartDateObj) {
            if (value >= 0) agg.sellsBefore += value;
            else if (value <= 0) agg.stocksBefore -= value;
          }
        }
      });

      currentPeriodAllBankTx.forEach((item: any) => {
        if (item.customerId && periodCustomerAggregates[item.customerId]) {
          const agg: any = periodCustomerAggregates[item.customerId];
          const itemDate: any = new Date(item.date);
          const income: number = Number(item.income) || 0;
          const outgoings: number = Number(item.outgoings) || 0;
          const bankGroup: any = bankGroupsMap_calc.get(
            item.bankGroupId?.toString()
          );
          let applyToBalComps: boolean = bankGroup?.includeInBalance;

          if (
            applyToBalComps &&
            item.bankGroupId &&
            excludedPaymentCategoryIds.length > 0
          ) {
            if (excludedPaymentCategoryIds.includes(item.bankGroupId)) {
              applyToBalComps = false;
            }
          }

          if (itemDate >= periodStartDateObj && itemDate <= periodEndDateObj) {
            if (income > 0) {
              agg.incomeTotal += income;
              if (applyToBalComps) agg.incomeWithoutBalance += income;
            } else if (outgoings > 0) {
              agg.outgoingTotal += outgoings;
              if (applyToBalComps) agg.outgoingWithoutBalance += outgoings;
            }
          } else if (itemDate < periodStartDateObj) {
            if (applyToBalComps) {
              if (income > 0) agg.incomeBefore += income;
              else if (outgoings > 0) agg.outgoingBefore += outgoings;
            }
          }
        }
      });

      // Format and calculate final customer balances
      Object.values(periodCustomerAggregates).forEach((data: any) => {
        data.stocksTotal = parseFloat(data.stocksTotal.toFixed(2));
        data.sellsTotal = parseFloat(data.sellsTotal.toFixed(2));
        data.incomeTotal = parseFloat(data.incomeTotal.toFixed(2));
        data.outgoingTotal = parseFloat(data.outgoingTotal.toFixed(2));
        data.stocksBefore = parseFloat(data.stocksBefore.toFixed(2));
        data.sellsBefore = parseFloat(data.sellsBefore.toFixed(2));
        data.incomeBefore = parseFloat(data.incomeBefore.toFixed(2));
        data.outgoingBefore = parseFloat(data.outgoingBefore.toFixed(2));
        data.incomeWithoutBalance = parseFloat(
          data.incomeWithoutBalance.toFixed(2)
        );
        data.outgoingWithoutBalance = parseFloat(
          data.outgoingWithoutBalance.toFixed(2)
        );
      });

      metrics.customerBalances.totalAccountsReceivable = 0;
      metrics.customerBalances.totalCustomerCreditsPayable = 0;

      Object.values(periodCustomerAggregates).forEach((data: any) => {
        const balWithoutB: number =
          data.sellsTotal -
          data.stocksTotal -
          data.incomeWithoutBalance +
          data.outgoingWithoutBalance;
        const balAtStart: number =
          data.sellsBefore -
          data.stocksBefore -
          data.incomeBefore +
          data.outgoingBefore +
          data.rawCustomerOpeningBalance;
        const finalBal: number = parseFloat(
          (balAtStart + (balWithoutB || 0)).toFixed(2)
        );

        let includeInGrandTotal: boolean = true;
        if (
          customerGroupInclusionFilters &&
          customerGroupInclusionFilters.length > 0
        ) {
          includeInGrandTotal = customerGroupInclusionFilters.includes(
            data.rawCustomerGroupId
          );
        }

        if (includeInGrandTotal) {
          if (finalBal >= 0)
            metrics.customerBalances.totalAccountsReceivable += finalBal;
          else metrics.customerBalances.totalCustomerCreditsPayable += finalBal;
        }
      });

      metrics.customerBalances.totalCustomerCreditsPayable = Math.abs(
        metrics.customerBalances.totalCustomerCreditsPayable
      );

      // V.F. OPTIMIZED Production Period Report (using formula-based calculation)
      const periodMaterialUsage = formulaCalculator.calculateTotalMaterialUsage(
        periodSpecificProductionTx
      );

      metrics.productionPeriodReport.totalMaterialsUsedQuantity =
        periodMaterialUsage.totalMaterialsUsedQuantity;
      metrics.productionPeriodReport.totalMaterialsUsedPrice =
        periodMaterialUsage.totalMaterialsUsedPrice;

      // Calculate production volume
      let currentTKG: number = 0;
      periodSpecificProductionTx.forEach((t: any) => {
        currentTKG +=
          (Number(t.quantity) || 0) *
          (Number(t.length) || 0) *
          (Number(t.weight) || 0) *
          (Number(t.width) || 1);
      });
      metrics.productionPeriodReport.productsProducedVolumeCalc =
        parseFloat(currentTKG?.toFixed(0)) ?? 0;

      // V.G. Profit & Loss for this Period (unchanged)
      const periodProfitCalcItems: any = {};
      periodSpecificSellsTx.forEach((sell: any) => {
        const { productId, materialId, quantity, price } = sell;
        const numQty: number = Number(quantity) || 0;
        const numPrice: number = Number(price) || 0;
        let itemCostVal: number = 0;
        let id: any = productId || materialId;

        if (productId) itemCostVal = getProductUnitCostLocal(productId);
        else if (materialId)
          itemCostVal = materialsMap_calc.get(materialId)?.price || 0;

        if (id) {
          periodProfitCalcItems[id] = periodProfitCalcItems[id] || {
            sellsValue: 0,
            costValue: 0,
          };
          periodProfitCalcItems[id].sellsValue += numQty * numPrice;
          periodProfitCalcItems[id].costValue += numQty * itemCostVal;
        }
      });

      Object.values(periodProfitCalcItems).forEach((item: any) => {
        metrics.profitAndLossPeriod.periodSellsValue += item.sellsValue;
        metrics.profitAndLossPeriod.periodCostOfGoodsSold += item.costValue;
      });

      // Administrative and other expenses calculation (unchanged)
      const adminExpBankGroupIds: string[] = bankGroupsList_calc
        .filter((bg: any) => bg.bankGroupCategory == 2)
        .map((bg: any) => bg.id?.toString());

      const otherExpBankGroupIds: string[] = bankGroupsList_calc
        .filter(
          (bg: any) =>
            bg.bankGroupCategory !== 1 &&
            bg.bankGroupCategory !== 2 &&
            bg.bankGroupCategory !== 4 &&
            bg.name !== "Köçürmə"
        )
        .map((bg: any) => bg.id);

      periodSpecificBankTx.forEach((tx: any) => {
        const bankGroupIdStr = tx.bankGroupId?.toString();
        if (bankGroupIdStr) {
          if (adminExpBankGroupIds.includes(bankGroupIdStr)) {
            metrics.profitAndLossPeriod.periodAdministrativeExpenses +=
              Number(tx.outgoings) || 0;
          }
          if (otherExpBankGroupIds.includes(tx.bankGroupId)) {
            metrics.profitAndLossPeriod.otherExpenses +=
              Number(tx.outgoings) || 0;
          }
        }
      });

      metrics.profitAndLossPeriod.periodGrossProfit =
        metrics.profitAndLossPeriod.periodSellsValue -
        metrics.profitAndLossPeriod.periodCostOfGoodsSold;

      // Final formatting
      const finalFormatRecursive = (obj: any) => {
        Object.keys(obj).forEach((key) => {
          if (typeof obj[key] === "number")
            obj[key] = parseFloat(obj[key].toFixed(2));
          else if (Array.isArray(obj[key]))
            obj[key].forEach((el) => {
              if (typeof el === "object" && el !== null)
                finalFormatRecursive(el);
            });
          else if (typeof obj[key] === "object" && obj[key] !== null)
            finalFormatRecursive(obj[key]);
        });
      };

      finalFormatRecursive(metrics);
      return metrics;
    };

    // --- Call for Current and Previous Periods ---
    const currentPeriodData: any = await calculateMetricsForPeriod(
      currentPeriodStartDateString,
      currentPeriodEndDateString,
      true
    );
    const previousPeriodData: any = await calculateMetricsForPeriod(
      previousPeriodDateStrings.startDateString,
      previousPeriodDateStrings.endDateString,
      false
    );

    // --- Construct Final Output ---
    const finalOutput: any = {
      currentPeriod: currentPeriodData,
      prevPeriod: previousPeriodData,
      currentPeriodRange: {
        startDate: currentPeriodStartDateString,
        endDate: currentPeriodEndDateString,
      },
      previousPeriodRange: {
        startDate: previousPeriodDateStrings.startDateString,
        endDate: previousPeriodDateStrings.endDateString,
      },
      percentageChanges: {},
    };

    const calculatePercentageChange = (
      currentVal?: number,
      previousVal?: number
    ): number | string | null => {
      const current: number = Number(currentVal);
      const previous: number = Number(previousVal);

      if (isNaN(current) || isNaN(previous)) return null;

      if (previous === 0) {
        if (current === 0) return 0;
        if (current > 0) return "New";
        if (current < 0) return "New Loss";
        return null;
      }
      const change: number = ((current - previous) / Math.abs(previous)) * 100;
      return parseFloat(change.toFixed(2));
    };

    // Populate percentage changes
    finalOutput.percentageChanges.sellsCurrentPeriod =
      calculatePercentageChange(
        currentPeriodData.sellsAnalysis?.sellsCurrentPeriod,
        previousPeriodData.sellsAnalysis?.sellsCurrentPeriod
      );
    finalOutput.percentageChanges.periodGrossProfit = calculatePercentageChange(
      currentPeriodData.profitAndLossPeriod?.periodGrossProfit,
      previousPeriodData.profitAndLossPeriod?.periodGrossProfit
    );
    finalOutput.percentageChanges.totalAccountsReceivable =
      calculatePercentageChange(
        currentPeriodData.customerBalances?.totalAccountsReceivable,
        previousPeriodData.customerBalances?.totalAccountsReceivable
      );
    finalOutput.percentageChanges.periodAdministrativeExpenses =
      calculatePercentageChange(
        currentPeriodData.profitAndLossPeriod?.periodAdministrativeExpenses,
        previousPeriodData.profitAndLossPeriod?.periodAdministrativeExpenses
      );
    finalOutput.percentageChanges.otherExpenses = calculatePercentageChange(
      currentPeriodData.profitAndLossPeriod?.otherExpenses,
      previousPeriodData.profitAndLossPeriod?.otherExpenses
    );
    finalOutput.percentageChanges.totalCashInBank = calculatePercentageChange(
      currentPeriodData.bankAnalysis?.inBalanceCurrentPeriod -
        currentPeriodData.bankAnalysis?.outBalanceCurrentPeriod,
      previousPeriodData.bankAnalysis?.inBalanceCurrentPeriod -
        previousPeriodData.bankAnalysis?.outBalanceCurrentPeriod
    );
    finalOutput.percentageChanges.totalMaterialsStockValue =
      calculatePercentageChange(
        currentPeriodData.inventoryValues?.currentTotalMaterialsValue,
        previousPeriodData.inventoryValues?.currentTotalMaterialsValue
      );
    finalOutput.percentageChanges.totalProductsStockValue =
      calculatePercentageChange(
        currentPeriodData.inventoryValues?.currentTotalProductsValue,
        previousPeriodData.inventoryValues?.currentTotalProductsValue
      );

    this.dataLoading = false;
    console.log("res: ", finalOutput);
    return finalOutput;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setGridOption("includeHiddenColumnsInQuickFilter", true);
    // this.gridApi.setIsExternalFilterPresent(
    //   () => filterTable !== false || chipSelected.length > 0
    // );
    // this.gridApi.setDoesExternalFilterPass(this.filterTableFn);
    this.gridApi.onFilterChanged();
    var defaultSortModel: ColumnState[] = [
      { colId: "sellsSum", sort: "desc", sortIndex: 0 },
    ];
    params.api.applyColumnState({ state: defaultSortModel });
  }

  applyFilter(val) {
    // filterTable = true;
    this.gridApi.setGridOption("quickFilterText", val);
    // this._customersService.sumDebit = 0;
    // this._customersService.sumKredit = 0;
    // this.gridApi.forEachNodeAfterFilterAndSort((node) => {
    //   this._customersService.sumDebit +=
    //     node.data.finalBalance >= 0 ? node.data.finalBalance : 0;
    //   this._customersService.sumKredit +=
    //     node.data.finalBalance < 0 ? node.data.finalBalance : 0;
    // });
  }

  async bankTransactionsDialog(type?: string) {
    this.dataLoading = true;
    let tableData: any[] = [];
    let dxData: any[] = []; // Initialize dxData as an array
    let colDefs: any[] | null = null;
    let dialogTitle: string = ""; // To hold the title for the dialog

    if (type == "sells") {
      dialogTitle = "Satışlar";
      tableData = await db.transactions
        .where("date")
        .between(
          this._dataService.startDate.value.format("YYYY-MM-DD"),
          this._dataService.endDate.value.format("YYYY-MM-DD"),
          true,
          true
        )
        .toArray()
        .then((transaction) =>
          transaction.filter(
            (t: any) => t.type == "Sells" || t.type == "Return"
          )
        );

      colDefs = [
        {
          headerName: "id",
          field: "id",
          hide: true,
        },
        {
          headerName: "Tərəf Müqabil",
          field: "customerName",
          sortable: true,
          flex: 3,
          minWidth: 150,
        },
        {
          headerName: "Toplam, AZN",
          field: "sum",
          sortable: true,
          flex: 2,
          minWidth: 120,
        },
        {
          headerName: "Tarix",
          field: "date",
          flex: 2,
          minWidth: 120,
          sortable: true,
        },
        { headerName: "Məlumat", field: "details", flex: 2, minWidth: 100 },
      ];
    } else {
      dxData = await db.bank // Use this.db to access the service instance
        .where("date")
        .between(
          this._dataService.startDate.value.format("YYYY-MM-DD"),
          this._dataService.endDate.value.format("YYYY-MM-DD"),
          true,
          true
        )
        .toArray()
        .then((bank) => bank.filter((b: any) => b.bankGroupId != 30));

      if (type == "sellsIncome") {
        dialogTitle = "Satış Gəlirləri";
        tableData = dxData.filter((b) => b.bankGroupId == 0);
        colDefs = this.columnDefs.filter((c) => c.field !== "outgoings");
      } else if (type == "otherIncome") {
        dialogTitle = "Digər Gəlirlər";
        const otherIncomeIds: string[] = this._dataService
          .bankGroups()
          .filter((bg: any) => bg.bankGroupCategory !== 2)
          .map((bg: any) => bg.id);
        let ids = this.status.currentPeriod.bankAnalysis.incomesByCategory
          .filter(
            (item: any) =>
              item.name !== "Satış" &&
              item.name !== "Köçürmə" &&
              otherIncomeIds.includes(item.bankGroupId)
          )
          .map((item: any) => item.bankGroupId);
        tableData = dxData.filter(
          (b) => ids.includes(b.bankGroupId) && b.income > 0
        );
        colDefs = this.columnDefs.filter((c) => c.field !== "outgoings");
      } else if (type == "xammalPayments") {
        dialogTitle = "Xammal Ödənişləri";
        let ids = this.status.currentPeriod.bankAnalysis.outgoingsByCategory
          .filter((item: any) => item.name == "Xammal")
          .map((item: any) => item.bankGroupId);
        tableData = dxData.filter(
          (b) => ids.includes(b.bankGroupId) && b.outgoings > 0
        );
        colDefs = this.columnDefs.filter((c) => c.field !== "income");
      } else if (type == "expenses") {
        dialogTitle = "Xərclər";
        let ids = this._dataService
          .bankGroups()
          .filter((category: any) => category.bankGroupCategory == 2)
          .map((category: any) => category.id);
        tableData = dxData.filter(
          (b) => ids.includes(b.bankGroupId) && b.outgoings > 0
        );
        colDefs = this.columnDefs.filter((c) => c.field !== "income");
      } else if (type == "otherExpenses") {
        dialogTitle = "Digər Xərclər";
        let ids = this._dataService
          .bankGroups()
          .filter(
            (bg: any) =>
              bg.bankGroupCategory !== 1 &&
              bg.bankGroupCategory !== 2 &&
              bg.bankGroupCategory !== 4
          )
          .map((category: any) => category.id);
        tableData = dxData.filter(
          (b) => ids.includes(b.bankGroupId) && b.outgoings > 0
        );
        console.log("ids: ", ids);
        colDefs = this.columnDefs.filter((c) => c.field !== "income");
      } else if (type == "menfeet") {
        dialogTitle = "Mənfəət";
        let ids = this._dataService
          .bankGroups()
          .filter((category: any) => category.bankGroupCategory == 4)
          .map((category: any) => category.id);
        tableData = dxData.filter(
          (b) => ids.includes(b.bankGroupId) && b.outgoings > 0
        );
        colDefs = this.columnDefs.filter((c) => c.field !== "income");
      }
    }

    tableData = tableData.map((transaction) => {
      const customerId = transaction.customerId;
      const customer = this._dataService
        .customers()
        .find((cust: any) => cust.id === customerId); // Cast to any if type not strict
      const bankGroup = this._dataService
        .bankGroups()
        .find((b: any) => b.id === transaction.bankGroupId); // Cast to any if type not strict

      if (customer) {
        return {
          ...transaction,
          customerName: customer?.name,
          bankGroup: bankGroup ? bankGroup.name : " ",
          details: transaction.transactionId?.details ?? "",
        };
      } else {
        // For bank transactions, customer might not exist, ensure bankGroup is added
        return {
          ...transaction,
          bankGroup: bankGroup ? bankGroup.name : " ",
          details: transaction.transactionId?.details ?? "", // Ensure details are handled
        };
      }
    });

    // Data passed to the TemplateRef, accessible via `let-dialogData`
    let dialogContentData = {
      title: dialogTitle,
      tableData: tableData,
      tableHeight: "500px",
      colDefs: colDefs,
      // You can also pass the dialogRef itself if you need to close from inside the template
      // dialogRef: this.dialogRef // This will be assigned after opening
    };

    this.dialogRef = this.dialog.open(this.tableDialogTemplate, {
      width: "800px",
      maxHeight: "700px",
      data: dialogContentData, // Pass the combined data to the template
      panelClass: "materialDialog",
    });

    this.dataLoading = false;

    // You no longer need to get componentInstance here as AgTableComponent is part of the template.
    // Instead, AgTableComponent needs to emit the rowClicked event.
    // The parent component (this component) will listen to it via (rowClicked)="onAgTableRowClicked($event)"
  }

  // Method to close the dialog, called from the template
  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  // Method to handle row clicks from AgTableComponent
  onAgTableRowClicked(clickedRowData: any): void {
    this._dataService.transactionDialog(
      clickedRowData.data?.transactionId?.id
        ? clickedRowData.data.transactionId
        : clickedRowData.data
    );
  }
}
